import { ACTION_TYPES, useGovernmentProjectSearchDispatch, useGovernmentProjectSearchState } from './government-project-search-context';
import GovernmentProjectAppService from '../../../../application/platform/apm/government-project/government-project-app-service';
import { IGovernmentProjectListResponse } from '../../../../model/apm/government-project/response/government-project-list-response';
import { IGovernmentProjectAddEditRequest } from '../../../../model/apm/government-project/request/government-project-add-edit-request';
import { IGovernmentProjectPagedRequest } from '../../../../model/apm/government-project/request/government-project-paged-request';
import { useActionRunner } from '../../../../hooks/use-action-runner';
import { useSearchActions } from '../../../../hooks/use-search-actions';
import { parseIdFilter } from '../../../../utils/filter-options';

export const useGovernmentProjectSearchController = () => {
    const dispatch = useGovernmentProjectSearchDispatch();
    const state = useGovernmentProjectSearchState();
    const { isSaving, runSaving, runWithLoading, run, showSuccess, confirmDelete } = useActionRunner();
    const { updateParameters, triggerSearch, ...searchHandlers } = useSearchActions<IGovernmentProjectPagedRequest>(
        dispatch, ACTION_TYPES, { term: undefined, type: undefined },
    );

    function handleOnChange(e: any) {
        const { name, value } = e.target;
        if (name === 'input-term') updateParameters({ term: value || undefined });
        if (name === 'select-type') updateParameters({ type: parseIdFilter(value) });
    }

    // A listagem não traz descrição e indicadores, então a edição busca o registro completo
    function openDrawer(row?: IGovernmentProjectListResponse) {
        if (!row) {
            dispatch({ type: ACTION_TYPES.openDrawer });
            return;
        }
        runWithLoading('Não foi possível carregar o projeto', async () => {
            dispatch({ type: ACTION_TYPES.openDrawer, payload: await GovernmentProjectAppService.getById(row.id) });
        });
    }

    function closeDrawer() {
        dispatch({ type: ACTION_TYPES.closeDrawer });
    }

    function handleSave(request: IGovernmentProjectAddEditRequest) {
        const editing = state.drawer.project;
        return runSaving('Não foi possível salvar o projeto', async () => {
            await (editing ? GovernmentProjectAppService.edit(editing.id, request) : GovernmentProjectAppService.add(request));
            showSuccess(editing ? 'Projeto atualizado com sucesso!' : 'Projeto cadastrado com sucesso!');
            closeDrawer();
            triggerSearch();
        });
    }

    function handleDelete(row: IGovernmentProjectListResponse) {
        confirmDelete(`Tem certeza que deseja excluir "${row.name}"?`, () => run('Não foi possível excluir o projeto', async () => {
            await GovernmentProjectAppService.remove(row.id);
            showSuccess('Projeto excluído com sucesso!');
            triggerSearch();
        }));
    }

    return {
        isSaving,
        handleOnChange, ...searchHandlers,
        openDrawer, closeDrawer, handleSave, handleDelete,
    };
};
